import React, { Fragment, useState,useRef, useEffect } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Card, CardBody, Container, Row, Col, Button, CardHeader, Collapse,Label, InputGroup, InputGroupAddon, InputGroupText, Input, Tooltip, ButtonGroup } from 'reactstrap';
import { useCaptureResults } from '../../../hooks/captureResultsSanitaria/useCaptureResults';
import { ViewExam } from './ViewExam';
import { useHistory } from 'react-router-dom';
import { ModalPreViewMedicalOrder } from '../../../components/ResultsCaptureSanitaria/ModalPreViewMedicalOrder';
import { ButtonGoBack, Email, exam } from '../../../constant';
import './styleCaptureResults.css';
import { ButtonValidate } from './ButtonValidate';
import { ModalConfirmReleaseAll } from '../../../components/ResultsCaptureSanitaria/ModalConfirmReleaseAll';
import { FileUpload } from 'primereact/fileupload';
import { Button as PrimeButton } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { chooseOptions, uploadOptions } from './fileUploadCaptureSanitary';
import { cedimi } from '../../../constant/globalConstantsTypeClients';
import { CurrencyBitcoin } from '@mui/icons-material';
import { ModalPrintI } from '../../../components/dashboard/default/ModalPrintI';
// console.log("🚀 ~ cedimi:", cedimi)

export const CaptureResultsFromNim = () => {
    const txtsection = localStorage.getItem('TextAS');
    const { analytes, profiles, sections, patient, saveIndividualAnalyte, saveAllAnalytes, releaseExam, releaseAll, validateAnalyte, 
        validateExam, validateProfile, printAvailable, dobleValidacion, resultsPartial, printWorkOrder, sendResultForEmail, observations, commentsPrintResult,
        handleEditCommentsPrintResults, saveCommentsWorkOrder,nimPatient,workMedicalOrderPDF, workMedicalOrderPDFLoading, workMedicalOrderPDFDownload,
        toggle, method, modal, typeModal, type_file, modalRelease, toggleRelease, loadingRelease, getViewPreview,
        loadingPatient,removeValidationFromExamOrProfile, backNim,nextNim,gotoNim,loadingButton,update_micro_type_result,
        pdfPreviewUrl, setPdfPreviewUrl, onTemplateSelect, onTemplateClear, showPreview, setShowPreview, fileUploadRef, workOrderStatus, canEditFiles, createUpload,
        attachedFiles, handleDeleteFile, handlePreviewFile,  loadingValidateSanitaryC, loadingReleaseExamSanitaryC, loadingRemoveSanitaryC, workOrderId,
        handleListPrint, togglePrintI, typeModalPrintI, modalPrintI, dataExams, handleCheckProfile, handleCheckAll, Impresionbyexam, id_workorder_print, handleCheckAllProfile, loading,
        letter, handleInputChange

    } = useCaptureResults();
    console.log("🚀 ~ dinosaurio ~ patient:", patient)



    const headerTemplate = ({ className, chooseButton, uploadButton }) => (
        <div
            className={className}
            style={{
                backgroundColor: 'transparent',
                display: 'flex',
                alignItems: 'center',
                padding: '0.5rem 0',
                borderBottom: '1px solid #46AFE5',
                justifyContent: 'space-between',
                gap: '0.5rem',
            }}
        >
            <div style={{ flexShrink: 0, paddingLeft: '8px' }}>
                {chooseButton}
            </div>

            <div style={{ display: 'flex', gap: '0.1rem', flexShrink: 0 }}>
                {uploadButton}
            </div>

        </div>
    );

    const emptyTemplate = (fileUploadRef, attachedFiles) => {

        const hasTemporaryFiles = attachedFiles.some(f => !f.saved);
        if (hasTemporaryFiles) return null;

        return (
            <div
                onClick={() => {
                    const input = fileUploadRef.current?.getInput?.() 
                            || fileUploadRef.current?.container?.querySelector('input[type="file"]');

                    if (input) {
                        input.click(); 
                    } else {
                        // console.warn("No se encontró el input de tipo file dentro de FileUpload");
                    }
                }}
                style={{
                    textAlign: 'center',
                    padding: '20px',
                    color: '#666',
                    border: '2px dashed #46afe5',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                }}
                onDragOver={(e) => (e.currentTarget.style.backgroundColor = '#e0f3ff')}
                onDragLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
                <Label style={{ fontSize: '12px', cursor: 'pointer' }}>
                    Arrastre o seleccione un archivo PDF
                </Label>
            </div>
        );
    };

    let url_helen = localStorage.getItem('url_helen');
    // console.log("🚀 ~ url_helen:", url_helen)

    let examCounter = 1;
    return (
        <Fragment>
            <Container fluid={true} className='position-relative pb-3 container-global-zoom'>
            {
                loadingPatient === true ?
                <Card className='floating-card p-1'>
                    <CardBody className='p-1'>
                        <ButtonGroup
                            vertical
                        >
                            <Button
                                block={true}
                                size="lg"
                                onClick={() => gotoNim(backNim)}
                                outline color='danger'
                               disabled={loadingButton || backNim == null}
                               className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            >
                                <i className="icofont icofont-arrow-right"></i>
                            </Button>
                            <Button
                                block={true}
                                size="lg"
                                onClick={() => gotoNim(nextNim)}
                                outline color='success'
                                disabled={loadingButton || nextNim == null}
                                className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            >
                                <i className="icofont icofont-arrow-left"></i>

                            </Button>
                            <Button
                                block={true}
                                size="lg "
                                onClick={saveAllAnalytes}
                                outline color='info'
                                disabled={loadingButton}
                               className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}
                                
                            >
                                <i className="icofont icofont-diskette"></i>
                            </Button>
                            <Button
                                block={true}
                                size="lg "
                                onClick={ () => getViewPreview(true) }
                                outline color='primary'
                            >
                                <i className="icofont icofont-document-search"></i>
                            </Button>
                            <Button
                                block={true}
                                size="sm "
                                outline color='dark'
                                onClick={() => window.location.href = `/busqueda/trabajo-dia`} 
                            >  
                                Regresar
                            </Button>
                        </ButtonGroup>
                    </CardBody>
                </Card>
                :
                ""
                }

                <Col sm="12" className='p-l-0 p-r-0' >
                    {
                        loadingPatient === false ?
                            <Col md="12" className='text-center p-l-0 p-r-0'>
                                <Card className='shadow' style={{ height: "380px" }}>
                                    <Row className='mt-2'> <br />
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center'>  <br /> <br /> <br /> <br />
                                            <img src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '130px' }} />
                                        </Col>
                                    </Row>
                                    <Row className='mt-2'>
                                        <Col sm="3" md="3" lg="3" className='text-center'></Col>
                                        <Col sm="2" md="2" lg="2" className='text-left p-r-0'>
                                            <p className='f-18 text-primary animate__animated animate__pulse animate__infinite'> <b>Cargando</b></p> <br />

                                        </Col>
                                        <Col sm="1" md="1" lg="1" className='text-center'>
                                            <br />
                                            <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                                        </Col>
                                        <Col sm="1" md="1" lg="1" className='text-center'>
                                            <br />
                                            <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle f-14"></i></p>
                                        </Col>
                                        <Col sm="1" md="1" lg="1" className='text-center'>
                                            <br />
                                            <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                                        </Col>
                                        <Col sm="2" md="2" lg="2" className='text-center'></Col>
                                    </Row>

                                </Card>
                            </Col>
                            :
                            <Card style={{textAlign:"center"}} className='height-equal pricingtable pt-0 pb-0 pr-0 pl-0'>

                                <Row className="m-0">

                                    <Col sm="4" className='p-l-0 d-none' >
                                        <Card className='shadow' style={{ height: "275px" }} >
                                            <CardHeader className='p-2 bg-primary'>
                                                <label className='p-1'>Datos del Paciente</label>
                                            </CardHeader>
                                            <Col sm="12">
                                                <Row>
                                                    <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-0 p-r-0' > <br />
                                                        {
                                                            (patient.name_gender) === "MASCULINO" ?
                                                                <div className="profile-vector"><img className="imgGender" src={require("../../../assets/images/loginHelenLabs/User/UserMen.svg")} style={{ width: "80%" }} alt="" /></div>
                                                                :
                                                                <div className="profile-vector"><img className="imgGender" src={require("../../../assets/images/loginHelenLabs/User/UserWoman.svg")} style={{ width: "80%" }} alt="" /></div>
                                                        }
                                                    </Col>

                                                    <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0' >
                                                        <Row>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="12"> <br />
                                                                <i className="fa fa-circle-o iconResults f-12"></i> <b className='labelPatient'>Nombre:</b><label className='pPatient'>{patient.name} {patient.paternal_surname} {patient.maternal_surname}</label><br />
                                                            </Col>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                <i className="fa fa-circle-o iconResults f-12"></i> <b className='labelPatient'>Edad:</b> <label className='pPatient'>{patient.age > 0 ? patient.age + " año(s)" : patient.format_age}  </label> <br />
                                                            </Col>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                <i className="fa fa-circle-o iconResults f-12"></i> <b className='labelPatient'>Sexo:</b> <label className='pPatient'>{patient.name_gender}</label>
                                                            </Col>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                <i className="fa fa-circle-o iconResults f-12"></i> <b className='labelPatient'>Nim:</b> <label className='pPatient'>{nimPatient}</label>
                                                            </Col>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                {
                                                                    patient.email === "" ?
                                                                        <div>
                                                                            <i className="fa fa-circle-o iconResults f-12 text-danger"></i>  <b className='labelPatient'>Email:</b>
                                                                            <label className='pPatient'>{"Sin correo registrado"}</label>
                                                                        </div>
                                                                        :
                                                                        <div>
                                                                            <i className="fa fa-circle-o iconResults f-12"></i>  <b className='labelPatient'>Email:</b> <label className='pPatient'>{patient.email}</label>
                                                                        </div>
                                                                }
                                                            </Col>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                {
                                                                    patient.phone === "" ?
                                                                        <div>
                                                                            <i className="fa fa-circle-o iconResults f-12 text-danger"></i> <b>Télefono:</b> <br /> <label className='pPatient'>{"Sin registro telefonico"}</label>
                                                                        </div>
                                                                        :
                                                                        <div>
                                                                            <i className="fa fa-circle-o iconResults f-12"></i>  <b>Télefono:</b> <label className='pPatient'>{patient.phone}</label>
                                                                        </div>
                                                                }
                                                            </Col>
                                                        </Row>

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Card>
                                    </Col>
                                    <Col sm={url_helen === cedimi ? 9 : 5} className='p-2'>
                                        <div style={{ backgroundColor: '#46afe5', color: 'white', padding: '8px 12px', borderRadius: '4px', marginBottom: '10px' }}>
                                            <h6 style={{ margin: 0 }}>Información del NIM: <b>{nimPatient}</b></h6>
                                        </div>
                                        <Col sm="12" className='text-left' style={{fontSize: '11px'}}>
                                            <Row>
                                                <Col xs="3" sm="3" md="3" lg="3" xl="3"  className="d-flex align-items-start justify-content-center">
                                                    <div className="profile-vector">
                                                        <img src={require("../../../assets/images/loginHelenLabs/WorkOrderDay/Ultrasonido.svg")} alt="" style={{ width: "100%", maxWidth: "150px", marginTop: "-5px"}} 
                                                        />
                                                    </div>
                                                </Col>

                                                <Col sm="9" className='p-l-0' >
                                                    <Row>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12"> <br />
                                                            {
                                                                observations == "" ?
                                                                    <div>
                                                                        <i className="icofont icofont-warning-alt  f-18 iconResults"></i>  <b className='labelPatient'>Observaciones:</b> <br />
                                                                        <label className='pPatient'>{"Sin observaciones"}</label>
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <i className="icofont icofont-warning-alt  f-18 text-danger"></i>  <b className='labelPatient' >Observaciones:</b> <br />
                                                                        <label className='pPatient'>{observations}</label>
                                                                    </div>
                                                            }
                                                        </Col>
                                                    
                                                    
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" >
                                                        <br />
                                                            <i className="fa fa-comment f-18 iconResults"></i><b>Comentarios adjuntos: </b> <br />
                                                            <InputGroup className='input-group-sm'>
                                                                <Input type="text" className='form-control form-control-sm input-air-primary' placeholder='Escribe tus comentarios' value={commentsPrintResult} onChange={(e) => handleEditCommentsPrintResults(e)} />
                                                                <InputGroupAddon addonType='append'>
                                                                    <InputGroupText>
                                                                        <Button className='p-0' color='transparent' size='xs' onClick={saveCommentsWorkOrder}>
                                                                            <i className='fa fa-save text-danger'></i>
                                                                        </Button>
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                        </Col>
                                                        
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Col>
                                    
                                    {
                                        url_helen !== cedimi ? (
                                            <Col sm="4"  className="p-2">
                                                <div
                                                        style={{
                                                            backgroundColor: '#46afe5',
                                                            color: 'white',
                                                            padding: '8px 12px',
                                                            borderRadius: '4px',
                                                            position: 'relative'
                                                        }}
                                                    >
                                                        <h6 style={{ margin: 0 }}>Insertar PDF</h6>

                                                         {!canEditFiles && (
                                                            <span
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    right: '8px',
                                                                    transform: 'translateY(-50%)',
                                                                    backgroundColor: '#dc3545',
                                                                    color: 'white',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '0.7rem'
                                                                }}
                                                                title="No se puede insertar archivos en este estatus"
                                                            >
                                                                PRUEBA LIBERADA
                                                            </span>
                                                        )}

                                                            </div>

                                                            <div
                                                                style={{
                                                                    pointerEvents: canEditFiles ? 'auto' : 'none',
                                                                    opacity: canEditFiles ? 1 : 0.5,
                                                                    marginTop: '8px',
                                                                    cursor: canEditFiles ? 'pointer' : 'not-allowed'
                                                                }}
                                                            >                                    
                                                    
                                                <FileUpload
                                                    ref={fileUploadRef}
                                                        name="files"
                                                        multiple
                                                        accept="application/pdf"
                                                        customUpload
                                                        uploadHandler={createUpload}
                                                        onSelect={onTemplateSelect}
                                                        onClear={onTemplateClear}
                                                        headerTemplate={headerTemplate}
                                                        chooseOptions={chooseOptions}
                                                        uploadOptions={uploadOptions}
                                                        emptyTemplate={() => emptyTemplate(fileUploadRef, attachedFiles)}
                                                        defaultFiles={attachedFiles}
                                                        className={attachedFiles && attachedFiles.length > 0 ? 'hide-fileupload-content' : ''}
                                                        itemTemplate={() => null} 



                                                    />
                                                    <div className="p-fileupload-content">
                                                        {attachedFiles.length > 0 ? (
                                                            attachedFiles.map(file => (
                                                                <div
                                                                    key={file.id_work_order_attached_file || file.name}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        width: '100%',
                                                                        borderBottom: '1px solid #eee',
                                                                        padding: '0.2rem 0',
                                                                        gap: '0.4rem',
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="fa fa-file-pdf-o"
                                                                        style={{ color: '#d9534f', fontSize: '1rem', flexShrink: 0 }}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            flex: 1,
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                            fontWeight: 600,
                                                                            fontSize: '0.85rem',
                                                                            textAlign: 'left',
                                                                        }}
                                                                        title={file.name}
                                                                    >
                                                                        {file.name}
                                                                    </span>
                                                                        <PrimeButton
                                                                            icon="pi pi-search"
                                                                            className="p-button-outlined p-button-sm"
                                                                            style={{
                                                                                backgroundColor: '#4589b1',
                                                                                color: 'white',
                                                                                height: '28px',    
                                                                                width: '28px',
                                                                                fontSize: '0.75rem', 
                                                                                padding: '0 6px'
                                                                            }}
                                                                            tooltip="Previsualizar PDF"
                                                                            tooltipOptions={{ position: 'top' }}
                                                                            onClick={() => handlePreviewFile(file)}
                                                                        />


                                                                        <PrimeButton
                                                                            icon="fa fa-trash-o"
                                                                            className="p-button-outlined p-button-sm"
                                                                            style={{
                                                                                backgroundColor: '#dc3545',
                                                                                color: 'white',
                                                                                height: '28px',
                                                                                width: '28px',
                                                                                fontSize: '0.75rem',
                                                                                padding: '0 6px'
                                                                            }}
                                                                        onClick={() => handleDeleteFile(file)}
                                                                        />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p></p>
                                                        )}
                                                    </div>

                                                </div>

                                                <Dialog
                                                    header="Previsualización de PDF"
                                                    visible={showPreview}
                                                    // style={{ width: '80vw', maxWidth: '900px' }}
                                                    modal
                                                    onHide={() => setShowPreview(false)}
                                                    className='large-dialog'
                                                    headerStyle={{
                                                    backgroundColor: '#0d3b59',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    }}             
                                                >
                                                {pdfPreviewUrl && (
                                                        <iframe
                                                            src={pdfPreviewUrl}
                                                            title="PDF Preview"
                                                            width="100%"
                                                            height="600px"
                                                            style={{ border: "none" }}
                                                        />
                                                    )}
                                                </Dialog>
                                            </Col>

                                        ) : null
                                        
                                    }
                                  
                                    <Col sm="3" className='p-2'>
                                            <div style={{ backgroundColor: '#46afe5', color: 'white', padding: '8px 12px', borderRadius: '4px', marginBottom: '10px' }}>
                                                <h6 style={{ margin: 0 }}>Acciones Generales</h6>
                                            </div>       
                                            <Row>
                                                <Col xs="2" sm="2" md="2" lg="2" xl="2">
                                                </Col>
                                                <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center'>
                                                    <ButtonGroup vertical>
                                                        {
                                                            printAvailable ?
                                                                resultsPartial ? <>
                                                                    {
                                                                        dobleValidacion ? <>
                                                                            <Button block={true} size="sm" onClick={sendResultForEmail} outline color="danger">
                                                                                Enviar resultaods
                                                                            </Button>
                                                                            {/* <Button block={true} size="sm" onClick={() => printWorkOrder(true)} outline color="primary">
                                                                                Imprimir resultados
                                                                            </Button>
                                                                             */}
                                                                            <Button block={true} size="sm" onClick={() => handleListPrint(workOrderId)} outline color="info">
                                                                                Imprimir resultados
                                                                            </Button>
                                                                        </>
                                                                            : ""
                                                                    }
                                                                <Button block={true} size="sm" onClick={() => getViewPreview(false)} outline color="primary">
                                                                                    Previsualizar
                                                                                </Button>
                                                                    <Button block={true} size="sm" onClick={saveAllAnalytes} outline color='info'>
                                                                        Guardar resultados
                                                                    </Button>
                                                                </>
                                                                    :

                                                                    dobleValidacion ? <>
                                                                        <Button block={true} size="sm" onClick={sendResultForEmail} outline color="primary">
                                                                            Enviar resultados
                                                                        </Button>
                                                                        {/* <Button block={true} size="sm" onClick={() => printWorkOrder(true)} outline color="primary">
                                                                            Imprimir resultados
                                                                        </Button> */}
                                                                           <Button block={true} size="sm" onClick={() => handleListPrint(workOrderId)} outline color="info">
                                                                                Imprimir resultados
                                                                            </Button>
                                                                    </> : ""
                                                                :
                                                                <Button block={true} size="sm" onClick={saveAllAnalytes} outline color='info'>
                                                                    Guardar resultados &nbsp;
                                                                </Button>
                                                        }
                                                        <Button block={true} size="sm" onClick={() => toggleRelease()} outline color='success'>
                                                            Liberar todo
                                                        </Button>
                                                    </ButtonGroup>
                                                    <Col xs="2" sm="2" md="2" lg="2" xl="2">
                                                    </Col>
                                                    {/* <Col sm="12" style={{ textAlign: "-webkit-center" }} > <br />
                                                        <Button color="light" className=" btn-air-light m-1" onClick={() => history.goBack()}><i className="icofont icofont-arrow-left"></i> {ButtonGoBack}</Button>
                                                    </Col> */}
                                                </Col>
                                            </Row>
                                    </Col>
                                </Row>
                        </Card>
                    }



                </Col>

                <Row style={{ zIndex: -1 }}>
                    {profiles.map((perfil, key) => {
                        let separador = 0;
                        const foliosMostrados = new Set();
                        const currentExamNumber = examCounter++;
                        return (
                            <Col sm="12" key={`perfil ` + key}>
                                {perfil.exams.length > 0 && (
                                    <>
                                        <CardHeader className="b-l-primary pb-2 pt-2 fondo ">
                                            <label className='Label-input'>{perfil.name} / Perfil</label>
                                            <div className='float-right'>
                                                {perfil.readyToValidateProfile && !perfil.readyToReleaseProfile ? (
                                                    <ButtonValidate
                                                        validateProfile={validateProfile}
                                                        ready={true}
                                                        id_profile={perfil.id_profile}
                                                        id_work_order={perfil.id_work_order}
                                                        id_work_order_profile={perfil.id_work_order_profile}
                                                    />
                                                ) : (
                                                    <ButtonValidate ready={false} />
                                                )}
                                            </div>
                                        </CardHeader>
                                        <CardBody className='p-l-0 p-r-0'>
                                            {perfil.exams.map((examen, key2) => {
                                                let id_mic_detail_sample = 0;
                                                if (separador !== examen.id_mic_detail_sample) {
                                                    separador = examen.id_mic_detail_sample;
                                                    id_mic_detail_sample = examen.id_mic_detail_sample;
                                                }

                                                const mostrarDatos = !foliosMostrados.has(examen.folio);
                                                if (mostrarDatos) foliosMostrados.add(examen.folio);

                                                return (
                                                    <ViewExam
                                                        key={key2}
                                                        id_mic_detail_sample={id_mic_detail_sample}
                                                        typeArray="profile"
                                                        sectionProfileId={perfil.id_profile}
                                                        releaseExam={releaseExam}
                                                        examen={examen}
                                                        mostrarDatos={mostrarDatos}
                                                        age={patient.age}
                                                        days_age={patient.days_age}
                                                        gender={patient.id_gender}
                                                        saveIndividualAnalyte={saveIndividualAnalyte}
                                                        validateAnalyte={validateAnalyte}
                                                        validateExam={validateExam}
                                                        analytes={analytes}
                                                        idPat={patient.id_patient}
                                                        namePatiente={patient.name + patient.paternal_surname + patient.maternal_surname}
                                                        nameP={patient.name}
                                                        surnameP={patient.paternal_surname}
                                                        surnameM={patient.maternal_surname}
                                                        curves={perfil.curves ?? null}
                                                        removeValidationFromExamOrProfile={removeValidationFromExamOrProfile}
                                                        update_micro_type_result={update_micro_type_result}
                                                        loadingValidateSanitaryC={loadingValidateSanitaryC}
                                                        loadingReleaseExamSanitaryC={loadingReleaseExamSanitaryC}
                                                        loadingRemoveSanitaryC={loadingRemoveSanitaryC}
                                                        examNumber={currentExamNumber}
                                                        showExamNumber={key2 === 0}
                                                    />
                                                );
                                            })}
                                        </CardBody>
                                    </>
                                )}
                            </Col>
                        );
                    })}

                    {sections.length > 0 &&
                        sections.map((seccion, key) => {
                            let separador = 0;

                            return (
                                <Col sm="12" key={key}>
                                    <CardHeader className="b-l-primary pb-2 pt-2 fondo ">
                                        <label className="Label-input">{seccion.name}-{txtsection}</label>
                                    </CardHeader>

                                    <CardBody className="p-l-0 p-r-0">
                                        {seccion.exams.map((examen, key2) => {
                                            let id_mic_detail_sample = 0;
                                            if (separador !== examen.id_mic_detail_sample) {
                                                separador = examen.id_mic_detail_sample;
                                                id_mic_detail_sample = examen.id_mic_detail_sample;
                                            }

                                            const mostrarDatos = true;

                                            const currentExamNumber = examCounter++;

                                            return (
                                                <ViewExam
                                                   key={key2}
                                                    id_mic_detail_sample={id_mic_detail_sample}
                                                    typeArray="section"
                                                    sectionProfileId={seccion.id}
                                                    releaseExam={releaseExam}
                                                    examen={examen}
                                                    age={patient.age}
                                                    days_age={patient.days_age}
                                                    gender={patient.id_gender}
                                                    saveIndividualAnalyte={saveIndividualAnalyte}
                                                    validateAnalyte={validateAnalyte}
                                                    validateExam={validateExam}
                                                    analytes={analytes}
                                                    idPat={patient.id_patient}
                                                    namePatiente={patient.name + patient.paternal_surname + patient.maternal_surname}
                                                    nameP={patient.name}
                                                    surnameP={patient.paternal_surname}
                                                    surnameM={patient.maternal_surname}
                                                    removeValidationFromExamOrProfile={removeValidationFromExamOrProfile}
                                                    update_micro_type_result={update_micro_type_result}
                                                    examNumber={currentExamNumber}      
                                                    loadingValidateSanitaryC={loadingValidateSanitaryC}
                                                    loadingReleaseExamSanitaryC={loadingReleaseExamSanitaryC} 
                                                    loadingRemoveSanitaryC={loadingRemoveSanitaryC}
                                                    mostrarDatos={mostrarDatos}
                                                    showExamNumber={true}
                                                />
                                            );
                                        })}
                                    </CardBody>
                                </Col>
                            );
                        })}
                </Row>
            </Container >
       
            <ModalPreViewMedicalOrder
                {
                ...{
                    modal, workMedicalOrderPDF, workMedicalOrderPDFDownload, 
                    loading, method, toggle, typeModal, type_file, workMedicalOrderPDFLoading,
                }
                }
            />

            <ModalPrintI
                {
                ...{
                    togglePrintI, typeModalPrintI, modalPrintI, dataExams, handleCheckProfile, handleCheckAll, Impresionbyexam, id_workorder_print, handleCheckAllProfile, loading, letter, handleInputChange
                }
                }
            />
            
            <ModalConfirmReleaseAll
                {...{
                    modalRelease, toggleRelease, loadingRelease, releaseAll
                }}
            />
          
        </Fragment >
    )
}
